module.exports = __webpack_public_path__ + "img/bill-right.cfd9943d.png";